<template>
  <div>
    <!-- 删除 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="delDialogVisible" width="480px" center>
      <div class="rowBox">
        <!-- 删除原因 -->
        <div class="label">
          {{ $t('message.reasonDeletion') }}:
        </div>
        <div class="val">
          <el-input type="textarea" v-model="delateData.deleted_reason"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="optionServiceDelete">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 删除数据
      delateData: {},
      delDialogVisible: false,
    };
  },
  methods: {
    // 服务单-删除
    optionServiceDelete() {
      if (this.delateData.deleted_reason == '') return this.$message.error('请输入删除原因')
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.optionServiceApi.deletePartial(this.delateData).then((res) => {
            this.$message.success(res.msg)
            this.$parent.optionServiceList()
            this.delDialogVisible = false

          });
        })
        .catch(() => { });
    },
  }
}
</script>
<style lang='scss' scoped>
.rowBox {
  display: flex;
  margin: 20px 20px 0;

  .label {
    width: 100px;
    line-height: 40px;
  }

  .val {
    flex: 1;
  }
}
</style>